<div class="bottom-info-component shr-bottominfo-message-component" fxLayout="row" fxLayoutAlign="start center">
    <div class="text">
        {{ message }}
    </div>
</div>
